export default {
    sections: ['details', 'image', 'password', 'sendgrid'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        role_id: {
            label: 'Role',
            section: 'details',
            position: 0,
        },
        name: {
            section: 'details',
            position: 1,
        },
        email: {
            section: 'details',
            position: 2,
        },
        event_name: {
            label: 'Event Name',
            section: 'details',
            position: 3,
        },
        image: {
            section: 'image',
            position: 0,
            description: 'Upload user\'s avatar here',
        },
        password: {
            section: 'password',
        },
        api_key_id: {
            section: 'sendgrid',
        },
        api_key: {
            section: 'sendgrid',
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.user.js